import type { ReactElement } from 'react';
import { PageHeader } from '@/shared/ui';
import { SupplierSettingsPanel } from '@/widgets/supplier-settings-panel';
export const SupplierSettingsPage = (): ReactElement => (
  <>
    <PageHeader
      title="사업자·입금 계좌"
      description="세금계산서에 사용할 사업자 정보와 계좌이체 입금 계좌를 관리합니다."
    />
    <SupplierSettingsPanel />
  </>
);
